import { render, staticRenderFns } from "./LooksItem.vue?vue&type=template&id=6ec5ba80&"
import script from "./LooksItem.vue?vue&type=script&lang=ts&"
export * from "./LooksItem.vue?vue&type=script&lang=ts&"
import style0 from "./LooksItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports